export default __webpack_public_path__ + "static/media/businessman.7debf49e.png";